export default __webpack_public_path__ + "static/media/22.9bf88d93.gif";